import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { CurrencyItem } from '@utils/models/Currency';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants/queryKeys';

export function useBasicCurrency() {
  return useQuery<CurrencyItem>(
    [queryKeys.CURRENCY_LIST_BASIC],
    async () => {
      const res = await $api.get(`/v1/currency/basic`);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}
